import { useMutation, useQueryClient } from '@tanstack/react-query';
import { metadataAPI } from '../api/enhancedApiService';

// NOTE: useTableProfile has been REMOVED - it was legacy code that directly queried Snowflake.
// Use useTableProfiling from useMetadataTiers.js instead, which reads from the tiered metadata cache.

/**
 * Custom hook to refresh/regenerate profile data for a table
 * UPDATED: Now triggers Tier 4 profiling instead of legacy /api/profile endpoint
 * @param {string} connectionId - The connection ID
 * @param {string} tableIdOrName - The table ID (from table_metadata_cache) or table name
 * @returns {Object} Mutation result object
 */
export const useRefreshTableProfile = (connectionId, tableIdOrName) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => {
      // Trigger Tier 4 profiling (new system - properly normalized)
      return metadataAPI.triggerTier(connectionId, 'tier4_profiling', {
        requestId: `profile-refresh-${connectionId}-${Date.now()}`
      });
    },
    onSuccess: (data) => {
      // Invalidate Tier 4 profiling cache to trigger refetch
      queryClient.invalidateQueries(['table-profiling', connectionId]);
      // Invalidate tier status to show updated profiling state
      queryClient.invalidateQueries(['tier-status', connectionId]);
      // Legacy: Also invalidate old profile cache (for backward compatibility during migration)
      queryClient.invalidateQueries(['table-profile', connectionId]);
      // Also invalidate statistics cache since they're related
      queryClient.invalidateQueries(['table-statistics', connectionId]);
    }
  });
};